//  @flow

import React from 'react';
import { useTranslation } from 'react-i18next';

import ImageBlurFallback from '../../Components/ImageBlurFallback';

type MissionContentProps = {
  title: string,
  text: string,
  image: string
};

const MissionContent = (props: MissionContentProps) => {
  const { title, text, image, webpImage, fallbackImage = '' } = props;
  const { t } = useTranslation();
  return (
    <div className="mission-content-box">
      <div className="mission-content-left">
        <ImageBlurFallback
          fallbackImage={fallbackImage}
          className="mission-content-left-img"
          webpImage={webpImage}
          src={image}
          alt={t('missioncontentImgAlt')}
        />
      </div>

      <div className="mission-content-right">
        <p>{title} </p>
        <span>{text}</span>
      </div>
    </div>
  );
};

export default MissionContent;



// WEBPACK FOOTER //
// ./src/Pages/AboutUs/MissionContent.js